import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { RecipeScannerPage } from './recipe-scanner-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [RecipeScannerPage],
    imports: [PagesModule, ComponentsModule]
})
export class RecipeScannerPageModule { }
